var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFoods(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4545 0C19.4545 13.8182 20.8265 22.4531 13.5591 22.4531V45.0448C13.5715 45.4361 13.5038 45.8257 13.3601 46.1897C13.2164 46.5537 12.9998 46.8843 12.7237 47.1611C12.4476 47.4379 12.1179 47.655 11.7548 47.799C11.3918 47.9431 11.0031 48.011 10.6128 47.9985C9.85512 47.9985 9.12843 47.6968 8.59264 47.1596C8.05686 46.6225 7.75585 45.894 7.75585 45.1343V22.3993C1.00623 22.3993 2.05961 13.9453 2.05961 0",
    stroke: "#F5A623",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81836 16V1.45459",
    stroke: "#F5A623",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6362 16V1.45459",
    stroke: "#F5A623",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6377 1.45459V45.2431C29.628 45.6017 29.691 45.9586 29.823 46.2928C29.955 46.6269 30.1533 46.9314 30.4061 47.1884C30.659 47.4454 30.9613 47.6496 31.2952 47.789C31.6291 47.9284 31.9878 48.0002 32.3502 48V48C33.0696 48 33.7595 47.7171 34.2682 47.2135C34.7769 46.7099 35.0627 46.0269 35.0627 45.3147V30.1338C38.0144 25.916 39.6665 20.941 39.8185 15.8121C39.7643 3.2448 29.6377 1.45459 29.6377 1.45459Z",
    stroke: "#F5A623",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFoods);
export default __webpack_public_path__ + "static/media/ic-foods.6c8d64d73c73d53a63d30fd7a6e2329c.svg";
export { ForwardRef as ReactComponent };